import React from 'react';
import jsCookie from "js-cookie";
import QRCode from "qrcode.react";
import ReactToPrint from 'react-to-print';

import { ApiUrl } from "../apiUrl";
import PrintQr from "../components/printQr";

class Account extends React.Component {

    state = {
        loading: true,
        error: null,
        infoError: null,
        success: null,
        data: null,
        meta: null,
        exhibitions: null,
        exh_selected: '',
        url_selected: '',
        original_filename: 'Ανεβάστε το Logo σας'

    }
    componentDidMount() {
        if (jsCookie.get("token")) {
            this.handleMe();
        }

    }


    handleChange = prop => event => {
        //const exhibitor = { ...this.state.exhibitor }
        this.setState({
            meta: { ...this.state.meta, [prop]: event.target.value }
        });
    };

    handleExhChange = prop => event => {
        //const exhibitor = { ...this.state.exhibitor }
        this.setState({
            [prop]: event.target.value
        });
    };

    getExhData = (id) => {
        const result = this.state.exhibitions
            .filter(e => e.id === id)
            .map(e => {

                return (
                    <div key={e.id} className="col-sm-12 col-md-4 ">
                        {e.title}
                    </div>
                )
            })

        return result;
    }


    createQr = async (
        e,
        exhibition,
        url,
        id
    ) => {
        e.preventDefault()
        if (

            exhibition === '' ||
            url === ''
        ) {
            this.setState({ error: 'Παρακαλώ συμπληρώστε όλα τα πεδία!' })
        } else {
            const data = {
                exhibition,
                url,
                id
            };
            await fetch(`${ApiUrl.apiUrl}/wp-json/orpheus/v1/createqr`, {
                method: "POST",
                xhrFields: { withCredentials: true },
                headers: {
                    Accept: 'application/json',
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + jsCookie.get("token"),

                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })

                .then(myJson => {
                    if (myJson.message) {
                        this.setState({

                            error: myJson.message,

                        })
                        return;

                    }
                    console.log(myJson)
                    this.setState({
                        data: myJson.data[0].acf.exhibitor,
                        id: myJson.data[0].id,
                        exhibitions: myJson.exhibitions,
                        success: 'Το Qr Stand δημιουργήθηκε επιτυχώς!',
                        loading: false,
                        exh_selected: '',
                        url_selected: ''
                    })
                })


        }
    };

    deleteQr = async (line) => {
        const id = this.state.id
        const row = line + 1;

        const data = {

            row,
            id
        };

        await fetch(`${ApiUrl.apiUrl}/wp-json/orpheus/v1/deleteqr`, {
            method: "POST",
            xhrFields: { withCredentials: true },
            headers: {
                Accept: 'application/json',
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + jsCookie.get("token"),

            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })

            .then(myJson => {
                console.log(myJson)
                this.setState({
                    data: myJson.data[0].acf.exhibitor,
                    id: myJson.data[0].id,
                    exhibitions: myJson.exhibitions,
                    error: myJson.message || null,
                    success: myJson.error ? null : 'Qr Stand διαγράφηκε!',
                    loading: false,
                    exh_selected: '',
                    url_selected: ''
                })
            })


    };

    handleFile = async (event) => {
        const apiUrl = 'https://api.cloudinary.com/v1_1/aristech/image/upload';
        const formData = new FormData();

        formData.append('file', event.target.files[0]);
        formData.append('upload_preset', 'qrstand ');
        try {
            await fetch(apiUrl, {
                method: "POST",
                body: formData
            })
                .then(response => {

                    return response.json();
                })
                .then(img => {

                    this.setState({
                        meta: { ...this.state.meta, exhibitor_logo: img.url },
                        original_filename: `${img.original_filename}.${img.format}`

                    })
                });
        } catch (error) {
            this.setState({
                infoError: error.message
            })

        }



    }


    handleMe = async () => {

        const apiUrl = `${ApiUrl.apiUrl}/wp-json/orpheus/v1/me`;
        this.setState({ loading: true });
        await fetch(apiUrl, {

            xhrFields: { withCredentials: true },
            headers: {
                Accept: 'application/json',
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + jsCookie.get("token"),

            }
        })
            .then(response => {
                return response.json();
            })
            .then(myJson => {

                this.setState({
                    data: myJson.data[0].acf.exhibitor,
                    id: myJson.data[0].id,
                    meta: myJson.meta,
                    exhibitions: myJson.exhibitions,
                    error: myJson.error || null,
                    loading: false,

                })

            })
            .catch(error => {
                this.setState({ error, loading: false });
            });

    }

    updateMe = async (
        e,
        company_name,
        exhibitor_phone,
        exhibitor_address,
        exhibitor_logo,
        user_email,
        description,
        user_url,
    ) => {
        e.preventDefault()
        if (
            company_name === '' ||
            exhibitor_phone === '' ||
            exhibitor_address === '' ||
            exhibitor_logo === '' ||
            user_email === '' ||
            description === '' ||
            user_url === ''
        ) {
            this.setState({ error: 'Παρακλώ συμπληρώστε όλα τα πεδία!' })
        } else {
            const meta = {

                company_name,
                exhibitor_phone,
                exhibitor_address,
                exhibitor_logo,
                user_email,
                description,
                user_url
            };
            await fetch(`${ApiUrl.apiUrl}/wp-json/orpheus/v1/update-author`, {
                method: "POST",
                xhrFields: { withCredentials: true },
                headers: {
                    Accept: 'application/json',
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + jsCookie.get("token"),

                },
                body: JSON.stringify(meta)
            })
                .then(response => {
                    return response.json();
                })
                .then(myJson => {
console.log(myJson)
                    this.setState({
                        data: myJson.data[0].acf.exhibitor,
                        id: myJson.data[0].id,
                        meta: myJson.meta,
                        exhibitions: myJson.exhibitions,
                        error: myJson.error || null,
                        infoError: 'Οι πληροφορίες αποθηκεύτηκαν επιτυχώς',
                        loading: false,
                    })
                })
                .catch(error => {
                    this.setState({ infoError: error, loading: false });
                });
        }
    };
    b64EncodeUnicode = (str) => {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
            }));
    }

    qrCode = (index, id, exhibition, user, url, company_name, size) => <QRCode value={btoa(`${index}|#|${id}|#|${exhibition}|#|${user}|#|${this.b64EncodeUnicode(url)}|#|${this.b64EncodeUnicode(company_name)}`)} size={size} level={"H"} />

    logOut = () => {
        jsCookie.set("token", '');
        this.props.history.push(`${process.env.PUBLIC_URL}/sign-in`);
    }

    render() {

        if (!jsCookie.get("token") || jsCookie.get("token") === "") {
            this.props.history.push(`${process.env.PUBLIC_URL}/sign-in`);
        }

        const meta = this.state.meta;
        // const data = this.state.data && this.state.data[0].acf.exhibitor;
        // const exhibitions = this.state.exhibitions && this.state.exhibitions;
        if (meta === null) {
            return null
        }



        return (
            <section className="authentication-form download">
                <nav className="navbar navbar-expand-lg navbar-light theme-nav fixed-top">
                    <div id="navbar-main" className="container">
                        <a className="navbar-brand" href={`${process.env.PUBLIC_URL}/`}><img src="assets/images/logo.png" alt="logo" /></a>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse default-nav" id="navbarSupportedContent">
                            <ul className="navbar-nav ml-auto" id="mymenu">

                                <li className="nav-item">
                                    <a className="nav-link" href={`${process.env.PUBLIC_URL}/`} >Αρχικη</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" style={{cursor: 'pointer'}}  onClick={() => this.logOut()} >Αποσυνδεση</a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </nav>

                <div className="innerpage-decor">
                    <div className="innerpage-circle1"><img src="assets/images/Testimonial2.png" alt="" /></div>
                    <div className="innerpage-circle2"><img src="assets/images/Testimonial1.png" alt="" /></div>
                </div>
                <div className="container">

                    <div className="row">
                        <div className="col-md-12 col-lg-8 col-sm-12">
                            <div className="contact-us">
                                <div className="w-100">
                                    <h2 className="title"><span>{meta.company_name} </span>Πληροφοριες</h2>
                                    <form className="theme-form" onSubmit={(e) => this.updateMe(
                                        e,
                                        this.state.meta.company_name,
                                        this.state.meta.exhibitor_phone,
                                        this.state.meta.exhibitor_address,
                                        this.state.meta.exhibitor_logo,
                                        this.state.meta.user_email,
                                        this.state.meta.description,
                                        this.state.meta.user_url
                                    )}>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6 md-fgrup-margin">
                                                    <input type="text" value={meta.company_name} className="form-control" placeholder="Επωνυμία Εταιρείας" required="required" onChange={
                                                        this.handleChange("company_name")} />
                                                </div>
                                                <div className="col-sm-12 col-md-6">
                                                    <input type="number" value={meta.exhibitor_phone} className="form-control" placeholder="Τηλέφωνο" required="required" onChange={
                                                        this.handleChange("exhibitor_phone")} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6 md-fgrup-margin">
                                                    <input type="email" value={meta.user_email} className="form-control" placeholder="e-mail" required="required" onChange={
                                                        this.handleChange("user_email")} />
                                                </div>
                                                <div className="col-sm-12 col-md-6">
                                                    <input type="text" value={meta.exhibitor_address} className="form-control" placeholder="Διεύθυνση" required="required" onChange={
                                                        this.handleChange("exhibitor_address")} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6 md-fgrup-margin">
                                                    <input type="text" value={meta.user_url} className="form-control" placeholder="Ιστοσελίδα" required="required" onChange={
                                                        this.handleChange("user_url")} />
                                                </div>
                                                <div className="col-sm-12 col-md-6">
                                                    <label className="form-control" htmlFor="file">{this.state.original_filename}</label>
                                                    <input

                                                        accept="image/*"
                                                        style={{ opacity: 0 }}
                                                        id="file"
                                                        onChange={this.handleFile}
                                                        multiple
                                                        type="file"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-12 md-fgrup-margin">
                                                    <textarea rows="5" value={meta.description} className="form-control" placeholder="Περιγραφή Εταιρείας" required="required" onChange={
                                                        this.handleChange("description")} />
                                                </div>

                                            </div>
                                        </div>
                                        {this.state.infoError && <div className="alert alert-success alert-dismissible fade show">
                                            {this.state.infoError} <button type="button" className="close" data-dismiss="alert">&times;</button>
                                        </div>}


                                        <div className="form-button">
                                            <button type="submit" className="btn btn-custom theme-color">Αποθηκευση</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 d-flex justify-content-center">
                            <div className="contact-right">
                                <img src={meta.exhibitor_logo} className="img-fluid" alt="" />

                            </div>
                        </div>
                    </div>
                    <div className='row mt-5'>
                        <div className="list-group col-md-12">

                            <div className="list-group-item list-group-item-action">
                                <div className="d-flex w-100 justify-content-between">
                                    <h5 className="mb-1"><strong>Δημιουργια νεου QR STAND</strong></h5>

                                </div>
                                <span className="mb-1">Επιλέξτε την έκθεση και το url της ιστοσελίδας σας (το url θα εμφανίζεται στον χρήστη της εφαρμογής).</span>
                                <form className="theme-form" onSubmit={(e) => this.createQr(
                                    e,
                                    this.state.exh_selected,
                                    this.state.url_selected,
                                    this.state.id
                                )} >
                                    <div className="form-group">
                                        <div className="row mt-5">
                                            <div className="col-sm-12 col-md-4">
                                                <div className="input-group">

                                                    <select className="custom-select selectpicker" data-live-search="true" onChange={this.handleExhChange('exh_selected')} value={this.state.exh_selected}>
                                                        <option>Επιλέξτε Έκθεση</option>
                                                        {this.state.exhibitions.map(exh => {
                                                            return (

                                                                <option key={exh.id} value={exh.id} data-tokens={exh.id}>{exh.title}</option>


                                                            )
                                                        })}

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 col-md-6">
                                                <input type="text" value={this.state.url_selected} className="form-control" placeholder="http://domain.com/special-page" required="required" onChange={
                                                    this.handleExhChange("url_selected")} />
                                            </div>
                                            <div className="col-sm-12 col-md-2 form-button">
                                                <button type="submit" className="btn btn-custom theme-color">Προσθηκη</button>
                                            </div>
                                        </div>
                                    </div>


                                    {this.state.error && <div className="alert alert-warning alert-dismissible fade show">
                                        {this.state.error} <button type="button" className="close" data-dismiss="alert">&times;</button>
                                    </div>}

                                </form>
                            </div>

                        </div>
                    </div>
                    {this.state.data && this.state.data.map((d, index) => {
                        return (
                            <div key={index} className='row mt-5'>
                                <div className="col-md-12 col-lg-8 col-sm-12">
                                    <div className="list-group">

                                        <div className="list-group-item list-group-item-action">
                                            <div className="d-flex w-100 justify-content-between">
                                                <h5 className="mb-1">QR Code ετοιμο για εκτυπωση</h5>
                                                <small className="text-muted">scans {d.scans}</small>
                                                <small className="text-muted"><button onClick={(e) => this.deleteQr(index)} className="btn btn-custom theme-color">&times;</button></small>
                                            </div>
                                            <p className="mb-1">Μπορείτε να εκτυπώσετε το qrcode σας σε απλό χαρτί Α4 .Το κουμπί εκτύπωσης Θα ετοιμάσει για σας 2 QR codes και τα σημεία κοπής.</p>
                                            {/* <small className="text-muted">Donec id elit non mi porta.</small> */}
                                            <div className="theme-form" >

                                                <div className="form-group">
                                                    <div className="row">
                                                        {this.getExhData(d.exhibition)}
                                                        <div className="col-sm-12 col-md-4">
                                                            {d.url}
                                                        </div>
                                                        <div className="col-sm-12 col-md-2 ">

                                                        </div>

                                                        <div className="col-sm-12 col-md-2">
                                                            <ReactToPrint
                                                                trigger={() => <button className="btn">Print Qr</button>}
                                                                content={() => this.componentRef}
                                                            />
                                                            <div style={{ display: 'none' }}>
                                                                <PrintQr logo={meta.exhibitor_logo} qrImage={this.qrCode(index, this.state.id, d.exhibition, d.user, d.url, this.state.meta.company_name, 350)} ref={el => (this.componentRef = el)} />
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 d-flex justify-content-center">
                                    <div className="contact-right">


                                        {this.qrCode(index, this.state.id, d.exhibition, d.user, d.url, this.state.meta.company_name, 150)}


                                    </div>
                                </div>
                            </div>

                        )
                    })}


                </div>

            </section>
        );
    }
}


export default Account;


// WEBPACK FOOTER //
// ./src/pages/account.js